export function summarizeActions(actions) {
  if (!Array.isArray(actions) || !actions.length) return "None";
  const preview = actions.slice(0, 2).map((action) => {
    if (action?.type === "SetUserStatus") {
      return `Set status ${action.status || ""}`;
    }
    if (action?.type === "ChangeGender") {
      return `Change gender to ${action.newGender || ""}`;
    }
    return action?.type || "Unknown";
  });
  const more = actions.length > 2 ? ` +${actions.length - 2}` : "";
  return `${preview.join(" • ")}${more}`;
}
